import { render } from "./PokemonPage.vue?vue&type=template&id=79ae846a"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__